import { createReducer } from '@mews/framework';
import {
    META_STATE_SUCCEEDED,
    META_STATE_STARTED,
    META_STATE_FAILED,
} from '@mews-commander/legacy-entities/src/constants';
import { TASKS_FETCH_STARTED, TASKS_FETCH_SUCCEEDED, TASKS_FETCH_FAILED } from '../actionTypes';

export const NAME = 'tasks';

export const reducer = createReducer(
    { ...META_STATE_SUCCEEDED },
    {
        [TASKS_FETCH_STARTED]: (state: $TSFixMe) => ({
            ...state,
            ...META_STATE_STARTED,
        }),
        [TASKS_FETCH_SUCCEEDED]: (state: $TSFixMe) => ({
            ...state,
            ...META_STATE_SUCCEEDED,
        }),
        [TASKS_FETCH_FAILED]: (state: $TSFixMe) => ({
            ...state,
            ...META_STATE_FAILED,
        }),
    }
);
